import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "p-2 sm:p-4" }
const _hoisted_2 = { class: "bg-white rounded-lg p-6 shadow" }
const _hoisted_3 = { class: "flex gap-4 mb-6 flex-wrap" }
const _hoisted_4 = { class: "w-full sm:min-w-[200px] sm:max-w-[400px]" }
const _hoisted_5 = { class: "w-full sm:min-w-[200px] sm:max-w-[400px]" }
const _hoisted_6 = { class: "w-full sm:min-w-[200px] sm:max-w-[400px]" }
const _hoisted_7 = { class: "space-y-2 mt-4" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center py-12"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center py-12 text-gray-400"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex items-center gap-3" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "w-24 h-24 rounded-lg overflow-hidden flex-shrink-0 bg-gray-50 border border-gray-100" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center"
}
const _hoisted_16 = { class: "font-semibold text-gray-800" }
const _hoisted_17 = { class: "flex items-center gap-4" }
const _hoisted_18 = { class: "text-gray-400 text-sm" }
const _hoisted_19 = {
  key: 0,
  class: "bg-white"
}
const _hoisted_20 = {
  key: 0,
  class: "flex items-center justify-between px-3 sm:px-5 py-2 sm:py-3 bg-purple-50/40 border-t border-b border-purple-100/60 flex-wrap gap-2"
}
const _hoisted_21 = { class: "flex items-center gap-3" }
const _hoisted_22 = ["onUpdate:modelValue", "onInput"]
const _hoisted_23 = ["onClick", "disabled"]
const _hoisted_24 = {
  key: 0,
  class: "inline-flex items-center"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "divide-y divide-gray-100 overflow-x-auto" }
const _hoisted_27 = { class: "w-20 h-20 rounded-lg overflow-hidden flex-shrink-0 bg-gray-50 border border-gray-100" }
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center"
}
const _hoisted_30 = { class: "min-w-[120px]" }
const _hoisted_31 = {
  key: 0,
  class: "text-xs text-gray-400 ml-1"
}
const _hoisted_32 = { class: "flex-1 flex items-center justify-end gap-2" }
const _hoisted_33 = { class: "flex items-center gap-1.5 flex-wrap" }
const _hoisted_34 = { class: "text-[11px] text-purple-500 font-semibold" }
const _hoisted_35 = ["onUpdate:modelValue", "onInput"]
const _hoisted_36 = { class: "flex items-center gap-1.5 flex-wrap" }
const _hoisted_37 = { class: "text-[11px] text-green-600 font-semibold" }
const _hoisted_38 = ["onUpdate:modelValue", "placeholder", "onInput"]
const _hoisted_39 = {
  key: 0,
  class: "w-3 h-3 border-2 border-green-400 border-t-transparent rounded-full animate-spin inline-block"
}
const _hoisted_40 = { class: "flex items-center gap-1.5 flex-wrap" }
const _hoisted_41 = { class: "text-[11px] text-blue-600 font-semibold" }
const _hoisted_42 = ["onUpdate:modelValue", "placeholder", "onInput"]
const _hoisted_43 = {
  key: 0,
  class: "w-3 h-3 border-2 border-blue-400 border-t-transparent rounded-full animate-spin inline-block"
}
const _hoisted_44 = ["onUpdate:modelValue", "placeholder", "onChange"]
const _hoisted_45 = ["onClick", "disabled"]
const _hoisted_46 = {
  key: 0,
  class: "inline-flex items-center"
}
const _hoisted_47 = { key: 1 }

import { ref, computed, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useNotification } from "@/composables/useNotification";
import { PageHeader, UnifiedPagination } from "@/components";
import {
  getProductsPage,
  getProduitCouleurs,
  saveProduitStocks,
  getProduitStocks,
  upsertProduitStock,
  updateCouleurDescriptionPaquet,
  type FilterProduitInput,
} from "@/api/produits";
import { getDeclinaisonById } from "@/api/gammesTailles";
import { getPackById } from "@/api/packs";
import { getProductPhotosBatch } from "@/api/shooting";
import { getProductImageUrl } from "@/config/api";

interface TailleStock {
  taille: string;
  quantity: number | null;
}

interface StockEntry {
  colorLabel: string;
  quantity: number;
  tailleStocks?: TailleStock[];
  idCouleur?: number;
}

interface ColorVariant {
  id: number;
  couleur: string;
}

interface StockItem {
  id: number;
  reference: string;
  referenceBase?: string;
  productName: string;
  venduPar: "couleurs" | "tailles" | "melangees";
  couleur?: string;
  size?: string;
  stock: number | null;
  stocks?: StockEntry[];
  colorVariants?: ColorVariant[];
  main?: boolean;
  liaison?: string;
  hasSiblings?: boolean;
  isChild?: boolean;
  isMelangee?: boolean;
  tailleStocks?: TailleStock[];
  idCouleur?: number;
  parentId?: number;
  bundleCount?: number;
  idPack?: number | null;
  packQuantites?: number[];
  image?: string;
  allPhotos?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StockManagementView',
  setup(__props) {

const router = useRouter();
const authStore = useAuthStore();
const { success: notifySuccess, error: notifyError } = useNotification();

// Extraire les tailles non vides d'une déclinaison (d1_FR à d12_FR)
const extractTaillesFromDeclinaison = (declinaison: any): string[] => {
  if (!declinaison) return [];
  const tailles = [
    declinaison.d1_FR,
    declinaison.d2_FR,
    declinaison.d3_FR,
    declinaison.d4_FR,
    declinaison.d5_FR,
    declinaison.d6_FR,
    declinaison.d7_FR,
    declinaison.d8_FR,
    declinaison.d9_FR,
    declinaison.d10_FR,
    declinaison.d11_FR,
    declinaison.d12_FR,
  ].filter((t): t is string => !!t && t.trim() !== "");
  return [...new Set(tailles)];
};

// Extraire les quantités du pack (p1 à p12)
const extractPackQuantites = (pack: any): number[] => {
  if (!pack) return [];
  return [
    pack.p1,
    pack.p2,
    pack.p3,
    pack.p4,
    pack.p5,
    pack.p6,
    pack.p7,
    pack.p8,
    pack.p9,
    pack.p10,
    pack.p11,
    pack.p12,
  ].filter((v): v is number => v != null && v !== 0);
};

// Chercher un stock existant pour une taille donnée, sans fallback (exact match uniquement)
const findExactStock = (
  stocksData: any[],
  idCouleur: number,
  taille: string,
) => {
  if (idCouleur === 0) {
    return stocksData.find((s) => s.taille === taille);
  }
  return stocksData.find(
    (s) => s.id_couleur === idCouleur && s.taille === taille,
  );
};

// Chercher un stock existant pour une taille donnée, avec fallback si idCouleur === 0
const findExistingStock = (
  stocksData: any[],
  idCouleur: number,
  taille: string,
) => {
  if (idCouleur === 0) {
    // Si idCouleur est 0 (non défini), chercher uniquement par taille
    const byTaille = stocksData.find((s) => s.taille === taille);
    if (byTaille) return byTaille;
    // Fallback: chercher sans taille (stock enregistré avec taille: null)
    return stocksData.find((s) => !s.taille);
  }
  const exact = stocksData.find(
    (s) => s.id_couleur === idCouleur && s.taille === taille,
  );
  if (exact) return exact;
  // Fallback: chercher par id_couleur sans taille (stock enregistré avec taille: null)
  return stocksData.find((s) => s.id_couleur === idCouleur && !s.taille);
};

const loading = ref(false);
const saving = ref<number | null>(null);
const autoSaving = ref<Record<string, boolean>>({});
const savingBundle = ref<number | null>(null);
const searchQuery = ref("");
const selectedVenduPar = ref("");
const selectedStockStatus = ref("");
const selectedColor = ref("");
const stocks = ref<StockItem[]>([]);
const expandedReferenceId = ref<number | null>(null);

const currentPage = ref(1);
const itemsPerPage = ref(10);
const totalProducts = ref(0);

const debounce = <T extends (...args: unknown[]) => void>(
  fn: T,
  delay: number,
) => {
  let timer: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

const debouncedLoadStocks = debounce(() => {
  currentPage.value = 1;
  expandedReferenceId.value = null;
  loadStocks();
}, 300);

const clearAllFilters = () => {
  searchQuery.value = "";
  selectedVenduPar.value = "";
  selectedStockStatus.value = "";
  selectedColor.value = "";
};

watch([searchQuery, selectedVenduPar, selectedStockStatus], () => {
  debouncedLoadStocks();
});

const toggleReferenceDropdown = (id: number) => {
  expandedReferenceId.value = expandedReferenceId.value === id ? null : id;
};

const getColorCount = (item: StockItem): number => {
  if (item.isMelangee && item.stocks) {
    return item.stocks.length;
  }
  const refBase =
    ((item.referenceBase || "").trim().toLowerCase() ||
      (item.reference || "").trim().toLowerCase()) +
    "||" +
    (item.venduPar || "couleurs");
  const group = stocks.value.filter((s) => {
    const sKey =
      ((s.referenceBase || "").trim().toLowerCase() ||
        (s.reference || "").trim().toLowerCase()) +
      "||" +
      (s.venduPar || "couleurs");
    return sKey === refBase && s.venduPar !== "melangees";
  });
  return group.length || 1;
};

const getChildItems = (item: StockItem): StockItem[] => {
  if (item.isMelangee && item.stocks) {
    return item.stocks.map((s, idx) => ({
      ...item,
      id: item.id * 1000 + idx,
      couleur: s.colorLabel,
      stock: s.quantity,
      stocks: undefined,
      tailleStocks: s.tailleStocks || [],
      isChild: true,
      isMelangee: true,
      idCouleur: s.idCouleur,
      parentId: item.id,
      image:
        item.allPhotos && item.allPhotos[idx] ? item.allPhotos[idx] : undefined,
    }));
  }

  const refBase =
    ((item.referenceBase || "").trim().toLowerCase() ||
      (item.reference || "").trim().toLowerCase()) +
    "||" +
    (item.venduPar || "couleurs");
  const group = stocks.value.filter((s) => {
    const sKey =
      ((s.referenceBase || "").trim().toLowerCase() ||
        (s.reference || "").trim().toLowerCase()) +
      "||" +
      (s.venduPar || "couleurs");
    return sKey === refBase && s.venduPar !== "melangees";
  });

  if (group.length > 0) {
    return group.map((child) => ({
      ...child,
      isChild: true,
      idCouleur: child.idCouleur,
    }));
  }

  return [{ ...item, isChild: true, idCouleur: item.idCouleur }];
};

// Computed: extract unique colors from loaded stocks
const availableColors = computed(() => {
  const uniqueColors = new Set<string>();
  stocks.value.forEach((item) => {
    if (item.couleur) {
      uniqueColors.add(item.couleur);
    }
  });
  return Array.from(uniqueColors).sort();
});

const filteredStocks = computed(() => {
  let result: StockItem[] = [];
  const processedRefBases = new Set<string>();

  stocks.value.forEach((item) => {
    const refBase =
      ((item.referenceBase || "").trim().toLowerCase() ||
        (item.reference || "").trim().toLowerCase()) +
      "||" +
      (item.venduPar || "couleurs");

    if (item.venduPar === "melangees") {
      if (processedRefBases.has(refBase)) return;

      if (item.stocks && item.stocks.length >= 1) {
        result.push({ ...item, hasSiblings: true, isMelangee: true });

        if (expandedReferenceId.value === item.id) {
          item.stocks.forEach((s, idx) => {
            result.push({
              ...item,
              id: item.id * 1000 + idx,
              couleur: s.colorLabel,
              stock: s.quantity,
              stocks: undefined,
              tailleStocks: s.tailleStocks || [],
              isChild: true,
              isMelangee: true,
            });
          });
        }
      } else {
        result.push({ ...item, hasSiblings: true, isMelangee: true });
      }

      processedRefBases.add(refBase);
      return;
    }

    if (processedRefBases.has(refBase)) return;

    const group = stocks.value.filter((s) => {
      const sKey =
        ((s.referenceBase || "").trim().toLowerCase() ||
          (s.reference || "").trim().toLowerCase()) +
        "||" +
        (s.venduPar || "couleurs");
      return sKey === refBase && s.venduPar !== "melangees";
    });

    if (group.length > 1) {
      let parentIndex = group.findIndex((g) => g.main);
      if (parentIndex === -1) parentIndex = 0;

      const parent = group[parentIndex];

      result.push({ ...parent, hasSiblings: true });
    } else {
      result.push({ ...item, hasSiblings: true });
    }

    processedRefBases.add(refBase);
  });

  if (selectedColor.value) {
    result = result.filter(
      (item) =>
        item.couleur?.toLowerCase() === selectedColor.value.toLowerCase(),
    );
  }

  return result;
});

const itemHasRecordedStock = (item: StockItem): boolean => {
  // For melangee: ALL stock entries must have ALL taille quantities non-null
  if (item.isMelangee && item.stocks) {
    return item.stocks.every(
      (s) =>
        s.tailleStocks &&
        s.tailleStocks.length > 0 &&
        s.tailleStocks.every((ts) => ts.quantity !== null),
    );
  }
  // For tailles: ALL children must have ALL tailleStocks non-null
  if (item.venduPar === "tailles") {
    const refBase = item.referenceBase || item.reference;
    const group = stocks.value.filter(
      (s) => (s.referenceBase || s.reference) === refBase,
    );
    return group.every((g) => {
      if (g.tailleStocks && g.tailleStocks.length > 0) {
        return g.tailleStocks.every((ts) => ts.quantity !== null);
      }
      return g.stock !== null;
    });
  }
  // For couleurs: ALL children must have stock non-null
  const refBase = item.referenceBase || item.reference;
  const group = stocks.value.filter(
    (s) => (s.referenceBase || s.reference) === refBase,
  );
  return group.every((g) => g.stock !== null);
};

const getVenduParLabel = (venduPar: string) => {
  const labels: Record<string, string> = {
    couleurs: "À la couleur",
    tailles: "À la taille",
    melangees: "Couleur mélangée",
  };
  return labels[venduPar] || venduPar;
};

const getVenduParClass = (venduPar: string) => {
  const classes: Record<string, string> = {
    couleurs: "bg-blue-100 text-blue-700",
    tailles: "bg-green-100 text-green-700",
    melangees: "bg-purple-100 text-purple-700",
  };
  return classes[venduPar] || "";
};

const handlePageChange = async (newPage: number) => {
  currentPage.value = newPage;
  expandedReferenceId.value = null;
  await loadStocks();
};

const handleItemsPerPageChange = async (newItemsPerPage: number) => {
  itemsPerPage.value = newItemsPerPage;
  currentPage.value = 1;
  expandedReferenceId.value = null;
  await loadStocks();
};

const loadStocks = async () => {
  loading.value = true;
  try {
    const id_vendeur = authStore.user?.id;
    const filter: FilterProduitInput = {
      id_vendeur,
      take: itemsPerPage.value,
      skip: (currentPage.value - 1) * itemsPerPage.value,
      orderBy: "dateCreation",
      orderDir: "DESC",
    };

    if (searchQuery.value && searchQuery.value.trim()) {
      (filter as any).reference = searchQuery.value.trim();
    }

    if (selectedVenduPar.value) {
      (filter as any).vendu_par = selectedVenduPar.value;
    }

    if (selectedStockStatus.value) {
      (filter as any).stockStatus =
        selectedStockStatus.value === "recorded" ? "recorded" : "not_recorded";
    }

    const page = await getProductsPage(filter);

    totalProducts.value = page.total;

    // First pass: create basic items
    const items: StockItem[] = page.items.map((p: any) => {
      const venduPar = p.vendu_par || "couleurs";
      const productId = p.id_produit || p.id;
      const item: StockItem = {
        id: productId,
        reference: p.reference || "",
        referenceBase: p.reference_base || "",
        productName: p.nom || "",
        venduPar,
        couleur: p.couleur || "",
        size: p.taille || "",
        stock: p.stock_value ?? p.stock ?? null,
        liaison: p.liaison || "",
        main: p.liaison && String(productId) === String(p.liaison),
        idCouleur: p.id_couleur || 0,
      };

      // Stocker id_pack pour les produits melangees et couleurs
      if ((venduPar === "melangees" || venduPar === "couleurs") && p.id_pack) {
        item.idPack = p.id_pack;
      }

      return item;
    });

    // Pour les produits melangees, charger les couleurs avec description_paquet
    const melangeeItems = items.filter((item) => item.venduPar === "melangees");
    await Promise.all(
      melangeeItems.map(async (item) => {
        try {
          // Récupérer les couleurs du produit avec description_paquet
          const couleurs = await getProduitCouleurs(item.id);

          if (!couleurs || couleurs.length === 0) {
            return;
          }

          // Récupérer la déclinaison (tailles) du produit
          const produit = page.items.find(
            (p: any) => (p.id_produit || p.id) === item.id,
          );
          const idDeclinaison = produit?.id_declinaison;

          let taillesList: string[] = [];
          if (idDeclinaison) {
            const declinaison = await getDeclinaisonById(idDeclinaison);
            taillesList = extractTaillesFromDeclinaison(declinaison);
          }

          // Construire le tableau stocks avec tailleStocks
          item.stocks = couleurs.map((c) => {
            const colorLabel = c.couleur?.couleur_FR || "";
            const idCouleur = c.id_couleur || 0;
            let tailleStocks: TailleStock[] = [];

            // Parser description_paquet pour obtenir les quantités par taille
            if (c.description_paquet && taillesList.length > 0) {
              try {
                let quantites: number[] = [];
                if (typeof c.description_paquet === "string") {
                  if (c.description_paquet.startsWith("[")) {
                    quantites = JSON.parse(c.description_paquet);
                  } else {
                    // Format "1,2,3" ou "1-2-3"
                    quantites = c.description_paquet
                      .split(/[-,]/)
                      .map((q: string) => parseInt(q.trim(), 10) || 0);
                  }
                }

                // Mapper les quantités aux tailles
                tailleStocks = taillesList.map((taille, idx) => ({
                  taille,
                  quantity: quantites[idx] || 0,
                }));
              } catch (e) {
                console.error(
                  "Erreur lors du parsing de description_paquet:",
                  e,
                );
              }
            } else if (taillesList.length > 0) {
              // Initialiser avec null (pas de données en base)
              tailleStocks = taillesList.map((taille) => ({
                taille,
                quantity: null,
              }));
            }

            return {
              colorLabel,
              idCouleur,
              quantity: tailleStocks.reduce((sum, ts) => sum + ts.quantity, 0),
              tailleStocks,
            };
          });

          // Charger les quantités du pack pour la validation
          if (item.idPack) {
            try {
              const pack = await getPackById(item.idPack);
              item.packQuantites = extractPackQuantites(pack);
            } catch (packErr) {
              console.error(
                `Erreur lors du chargement du pack pour le produit ${item.id}:`,
                packErr,
              );
            }
          }

          // Charger le nombre de paquets (bundleCount) depuis produits_stock avec id_couleur = 43
          try {
            const stocksData = await getProduitStocks(item.id);
            // id_couleur 43 est l'ID spécial pour les couleurs mélangées
            const melangeeStock = stocksData.find((s) => s.id_couleur === 43);
            item.bundleCount = melangeeStock?.value ?? 0;
          } catch (stockErr) {
            console.error(
              `Erreur lors du chargement du stock pour le produit ${item.id}:`,
              stockErr,
            );
            item.bundleCount = 0;
          }
        } catch (err) {
          console.error(
            `Erreur lors du chargement des couleurs pour le produit ${item.id}:`,
            err,
          );
        }
      }),
    );

    // Pour les produits tailles, charger les stocks par taille pour chaque couleur
    const taillesItems = items.filter((item) => item.venduPar === "tailles");
    await Promise.all(
      taillesItems.map(async (item) => {
        try {
          const produit = page.items.find(
            (p: any) => (p.id_produit || p.id) === item.id,
          );
          const idDeclinaison = produit?.id_declinaison;

          let taillesList: string[] = [];
          if (idDeclinaison) {
            const declinaison = await getDeclinaisonById(idDeclinaison);
            taillesList = extractTaillesFromDeclinaison(declinaison);
          }

          if (taillesList.length === 0) return;

          const stocksData = await getProduitStocks(item.id);

          const hasMultipleTailles = taillesList.length > 1;
          item.tailleStocks = taillesList.map((taille) => {
            const existingStock = hasMultipleTailles
              ? findExactStock(stocksData, item.idCouleur ?? 0, taille)
              : findExistingStock(stocksData, item.idCouleur ?? 0, taille);
            return {
              taille,
              quantity:
                existingStock !== undefined ? existingStock.value : null,
            };
          });

          item.stock = item.tailleStocks.reduce(
            (sum, ts) => sum + (ts.quantity ?? 0),
            0,
          );
        } catch (err) {
          console.error(
            `Erreur lors du chargement des tailles pour le produit ${item.id}:`,
            err,
          );
        }
      }),
    );

    // Pour les produits couleurs, charger aussi les tailles et packs si id_declinaison existe
    const couleursItems = items.filter((item) => item.venduPar === "couleurs");
    await Promise.all(
      couleursItems.map(async (item) => {
        try {
          const produit = page.items.find(
            (p: any) => (p.id_produit || p.id) === item.id,
          );
          const idDeclinaison = produit?.id_declinaison;

          if (!idDeclinaison) {
            // Pas de déclinaison : charger le stock simple
            // Compter les couleurs du produit pour déterminer la logique
            try {
              const produitCouleurs = await getProduitCouleurs(item.id);
              const nbCouleurs =
                produitCouleurs?.filter((pc: any) => pc.id_couleur != null)
                  .length ?? 0;

              if (nbCouleurs <= 1) {
                // Une seule couleur (ou aucune) : utiliser stock_value (SUM) comme ProductListView
                const produitData = page.items.find(
                  (p: any) => (p.id_produit || p.id) === item.id,
                );
                const stockRenseigne = (produitData as any)?.stock_renseigne;
                const stockValue = produitData?.stock_value;
                item.stock =
                  stockRenseigne && stockValue != null
                    ? Number(stockValue)
                    : null;
              } else {
                // Plusieurs couleurs : charger depuis produits_stock par id_couleur
                const stocksData = await getProduitStocks(item.id);
                if (stocksData.length > 0) {
                  const match =
                    item.idCouleur && item.idCouleur !== 0
                      ? stocksData.find((s) => s.id_couleur === item.idCouleur)
                      : stocksData[0];
                  if (match) {
                    item.stock = match.value ?? null;
                  }
                }
              }
            } catch (stockErr) {
              console.error(
                `Erreur lors du chargement du stock simple pour le produit couleur ${item.id}:`,
                stockErr,
              );
            }
            return;
          }

          let taillesList: string[] = [];
          const declinaison = await getDeclinaisonById(idDeclinaison);
          taillesList = extractTaillesFromDeclinaison(declinaison);

          if (taillesList.length === 0) return;

          const stocksData = await getProduitStocks(item.id);

          const hasMultipleTailles = taillesList.length > 1;
          item.tailleStocks = taillesList.map((taille) => {
            const existingStock = hasMultipleTailles
              ? findExactStock(stocksData, item.idCouleur ?? 0, taille)
              : findExistingStock(stocksData, item.idCouleur ?? 0, taille);
            return {
              taille,
              quantity:
                existingStock !== undefined ? existingStock.value : null,
            };
          });

          // Pour les produits avec une seule taille : si aucun stock par taille n'a été trouvé,
          // utiliser stock_value du produit (synchronisé depuis ProductListView)
          if (
            taillesList.length === 1 &&
            item.tailleStocks.length === 1 &&
            item.tailleStocks[0].quantity === null
          ) {
            const produitData = page.items.find(
              (p: any) => (p.id_produit || p.id) === item.id,
            );
            const stockRenseigne = (produitData as any)?.stock_renseigne;
            const stockValue = produitData?.stock_value;
            if (stockRenseigne && stockValue != null) {
              item.tailleStocks[0].quantity = Number(stockValue);
            }
          }

          item.stock = item.tailleStocks.reduce(
            (sum, ts) => sum + (ts.quantity ?? 0),
            0,
          );

          if (item.idPack) {
            try {
              const pack = await getPackById(item.idPack);
              item.packQuantites = extractPackQuantites(pack);
            } catch (packErr) {
              console.error(
                `Erreur lors du chargement du pack pour le produit couleur ${item.id}:`,
                packErr,
              );
            }
          }
        } catch (err) {
          console.error(
            `Erreur lors du chargement des tailles pour le produit couleur ${item.id}:`,
            err,
          );
        }
      }),
    );

    // Second pass: group by reference_base to build colorVariants
    const refBaseGroups = new Map<string, StockItem[]>();
    items.forEach((item) => {
      const key = item.referenceBase || item.reference;
      if (!refBaseGroups.has(key)) {
        refBaseGroups.set(key, []);
      }
      refBaseGroups.get(key)!.push(item);
    });

    // Assign colorVariants to each item
    items.forEach((item) => {
      const key = item.referenceBase || item.reference;
      const group = refBaseGroups.get(key) || [];
      item.colorVariants = group.map((g) => ({
        id: g.id,
        couleur: g.couleur || "",
      }));
    });

    // Charger les photos en batch pour tous les produits
    try {
      const allIds = items.map((item) => item.id);
      const { success, photosByProduct } = await getProductPhotosBatch(allIds);

      // Pour les produits mélangées, charger toutes les photos (full=true)
      const melangeeIds = items
        .filter((item) => item.venduPar === "melangees")
        .map((item) => item.id);
      let fullPhotosByProduct: Record<number, string[]> = {};
      if (melangeeIds.length > 0) {
        const fullResult = await getProductPhotosBatch(melangeeIds, true);
        if (fullResult.success) {
          fullPhotosByProduct = fullResult.photosByProduct;
        }
      }

      if (success && photosByProduct) {
        for (const item of items) {
          if (item.venduPar === "melangees" && fullPhotosByProduct[item.id]) {
            item.allPhotos = fullPhotosByProduct[item.id].map((p) =>
              getProductImageUrl(String(p)),
            );
            item.image = item.allPhotos[0] || undefined;
          } else {
            const photos = photosByProduct[item.id];
            const first =
              Array.isArray(photos) && photos.length ? photos[0] : undefined;
            if (first) {
              item.image = getProductImageUrl(String(first));
            }
          }
        }
      }
    } catch {
      // Ignorer les erreurs de chargement d'images
    }

    stocks.value = items;
  } catch (error) {
    console.error("Erreur lors du chargement des stocks:", error);
  } finally {
    loading.value = false;
  }
};

const autoSaveTailleStock = async (child: StockItem, ts: TailleStock) => {
  const key = `${child.id}-${ts.taille}`;
  autoSaving.value[key] = true;
  try {
    const idCouleur = child.idCouleur || child.colorVariants?.[0]?.id || 0;
    if (!idCouleur) {
      console.error("No color ID found for auto-save tailles item:", child);
      return;
    }
    const quantity = Math.max(0, Math.floor(Number(ts.quantity) || 0));
    await upsertProduitStock(child.id, idCouleur, quantity, ts.taille);

    notifySuccess("Stock enregistré avec succès!");

    // Update local state
    const stockItem = stocks.value.find((s) => s.id === child.id);
    if (stockItem && stockItem.tailleStocks) {
      const localTs = stockItem.tailleStocks.find(
        (t) => t.taille === ts.taille,
      );
      if (localTs) localTs.quantity = quantity;
      stockItem.stock = stockItem.tailleStocks.reduce(
        (sum, t) => sum + (t.quantity ?? 0),
        0,
      );
    }
  } catch (error) {
    console.error("Error auto-saving taille stock:", error);
    notifyError("Erreur lors de l'enregistrement automatique du stock");
  } finally {
    autoSaving.value[key] = false;
  }
};

const tailleDebounceTimers = new Map<string, ReturnType<typeof setTimeout>>();
const debouncedAutoSaveTailleStock = (child: StockItem, ts: TailleStock) => {
  const key = `${child.id}-${ts.taille}`;
  const existing = tailleDebounceTimers.get(key);
  if (existing) clearTimeout(existing);
  tailleDebounceTimers.set(
    key,
    setTimeout(() => {
      tailleDebounceTimers.delete(key);
      autoSaveTailleStock(child, ts);
    }, 800),
  );
};

const sanitizeNonNegativeInt = (obj: any, key: string) => {
  const val = obj[key];
  if (val === null || val === undefined) return;
  if (val === "" || isNaN(val) || val < 0) {
    obj[key] = 0;
  } else {
    obj[key] = Math.floor(val);
  }
};

const updateStock = (item: StockItem) => {
  if (item.stock === null || item.stock === undefined) {
    return;
  }
  if (item.stock < 0 || isNaN(item.stock)) {
    item.stock = 0;
  } else {
    item.stock = Math.floor(item.stock);
  }
  // Sync edited value back to stocks.value (template uses spread copies from getChildItems)
  const stockItem = stocks.value.find((s) => s.id === item.id);
  if (stockItem) {
    stockItem.stock = item.stock;
  }
};

const saveAllChildren = async (parentItem: StockItem) => {
  saving.value = parentItem.id;
  try {
    if (parentItem.isMelangee) {
      // Validation: vérifier que la somme des quantités des couleurs = quantités du pack
      if (
        parentItem.packQuantites &&
        parentItem.packQuantites.length > 0 &&
        parentItem.stocks &&
        parentItem.stocks.length > 0
      ) {
        const packQtes = parentItem.packQuantites;
        const sommeQuantites: number[] = new Array(packQtes.length).fill(0);

        for (const s of parentItem.stocks) {
          if (s.tailleStocks && s.tailleStocks.length > 0) {
            s.tailleStocks.forEach((ts, idx) => {
              if (idx < sommeQuantites.length) {
                sommeQuantites[idx] += ts.quantity ?? 0;
              }
            });
          }
        }

        let mismatch = false;
        for (let i = 0; i < packQtes.length; i++) {
          if (packQtes[i] !== sommeQuantites[i]) {
            mismatch = true;
            break;
          }
        }

        if (mismatch) {
          notifyError(
            `La somme des quantités des couleurs (${sommeQuantites.join(
              "-",
            )}) ne correspond pas aux quantités du paquet (${packQtes.join(
              "-",
            )})`,
          );
          saving.value = null;
          return;
        }
      }

      // For melangee, use getChildItems (stocks are in parentItem.stocks)
      const children = getChildItems(parentItem);
      for (const child of children) {
        await saveStock(child);
      }
    } else {
      // For couleurs/tailles, read directly from stocks.value to get edited values
      const refBase = parentItem.referenceBase || parentItem.reference;
      const group = stocks.value.filter(
        (s) =>
          (s.referenceBase || s.reference) === refBase &&
          s.venduPar !== "melangees",
      );
      const children = group.length > 0 ? group : [parentItem];
      for (const child of children) {
        await saveStock({
          ...child,
          isChild: true,
          idCouleur: child.idCouleur,
        });
      }
    }
    notifySuccess("Stock enregistré avec succès!");
  } catch (error) {
    console.error("Error saving all children:", error);
    notifyError("Erreur lors de l'enregistrement du stock");
  } finally {
    saving.value = null;
  }
};

const saveStock = async (item: StockItem) => {
  try {
    if (item.isMelangee && item.tailleStocks && item.tailleStocks.length > 0) {
      // Melangees type: update description_paquet in couleurs_produits
      const productId = item.parentId || item.id;
      const idCouleur = item.idCouleur;

      if (!idCouleur) {
        console.error("No color ID found for item:", item);
        notifyError("Erreur: ID couleur non trouvé");
        return;
      }

      // Build new description_paquet from tailleStocks
      const newDescriptionPaquet = item.tailleStocks
        .map((ts) => ts.quantity ?? 0)
        .join("-");

      // Use the new API to update only this color's description_paquet
      await updateCouleurDescriptionPaquet(
        productId,
        idCouleur,
        newDescriptionPaquet,
      );

      // Update local state
      const parentItem = stocks.value.find((s) => s.id === productId);
      if (parentItem && parentItem.stocks) {
        const stockEntry = parentItem.stocks.find(
          (s) => s.idCouleur === item.idCouleur,
        );
        if (stockEntry) {
          stockEntry.tailleStocks = [...item.tailleStocks];
          stockEntry.quantity = item.tailleStocks.reduce(
            (sum, ts) => sum + (ts.quantity ?? 0),
            0,
          );
        }
      }
    } else if (item.tailleStocks && item.tailleStocks.length > 0) {
      // Tailles type: update produits_stock for each taille
      const idCouleur = item.idCouleur || item.colorVariants?.[0]?.id || 0;

      if (!idCouleur) {
        console.error("No color ID found for tailles item:", item);
        notifyError("Erreur: ID couleur non trouvé");
        return;
      }

      // Save each taille stock using upsertProduitStock (skip null quantities)
      const taillesToSave = item.tailleStocks.filter(
        (ts) => ts.quantity !== null && ts.quantity !== undefined,
      );
      if (taillesToSave.length === 0) return;
      await Promise.all(
        taillesToSave.map(async (ts) => {
          await upsertProduitStock(
            item.id,
            idCouleur,
            ts.quantity ?? 0,
            ts.taille,
          );
        }),
      );

      // Update local state
      const stockItem = stocks.value.find((s) => s.id === item.id);
      if (stockItem) {
        stockItem.tailleStocks = [...item.tailleStocks];
        stockItem.stock = item.tailleStocks.reduce(
          (sum, ts) => sum + (ts.quantity ?? 0),
          0,
        );
      }
    } else {
      // Couleurs type: update produits_stock with single value (upsert to avoid deleting other colors)
      const idCouleur = item.idCouleur || item.colorVariants?.[0]?.id || 0;

      if (!idCouleur) {
        console.error("No color ID found for couleurs item:", item);
        return;
      }

      if (item.stock === null || item.stock === undefined) {
        return; // Ne pas enregistrer si aucune valeur n'a été saisie
      }
      const stockValue = item.stock < 0 ? 0 : item.stock || 0;
      await upsertProduitStock(
        item.id,
        idCouleur,
        stockValue,
        item.size || null,
      );

      // Update local state
      const stockItem = stocks.value.find((s) => s.id === item.id);
      if (stockItem) {
        stockItem.stock = item.stock;
      }
    }
  } catch (error) {
    console.error("Error saving stock:", error);
    throw error;
  }
};

// Sauvegarder le nombre de paquets (捆数) pour les produits couleur mélangée
const saveBundleCount = async (item: StockItem) => {
  savingBundle.value = item.id;
  try {
    const bundleCount = item.bundleCount ?? 0;

    // id_couleur 43 est l'ID spécial pour les couleurs mélangées
    const ID_COULEUR_MELANGEES = 43;

    // Utiliser upsertProduitStock pour ne pas supprimer les autres enregistrements de stock
    await upsertProduitStock(item.id, ID_COULEUR_MELANGEES, bundleCount, null);

    // Mettre à jour l'état local
    const stockItem = stocks.value.find((s) => s.id === item.id);
    if (stockItem) {
      stockItem.bundleCount = bundleCount;
    }

    notifySuccess("Nombre de paquets enregistré avec succès!");
  } catch (error) {
    console.error("Error saving bundle count:", error);
    notifyError("Erreur lors de l'enregistrement du nombre de paquets");
  } finally {
    savingBundle.value = null;
  }
};

onMounted(async () => {
  if (!authStore.isInitialized) {
    await authStore.checkAuth();
  }

  if (!authStore.isAuthenticated) {
    router.push({ name: "auth" });
    return;
  }

  await loadStocks();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PageHeader), { title: "Gestion de stock" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("label", {
            for: "search",
            class: "block mb-2 font-medium"
          }, "Rechercher", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            placeholder: "Rechercher par référence",
            class: "w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
          }, null, 512), [
            [
              _vModelText,
              searchQuery.value,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            for: "venduPar",
            class: "block mb-2 font-medium"
          }, "Type de vente", -1)),
          _withDirectives(_createElementVNode("select", {
            id: "venduPar",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedVenduPar).value = $event)),
            class: "w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("option", { value: "" }, "Tous", -1),
            _createElementVNode("option", { value: "couleurs" }, "Vendu par couleur", -1),
            _createElementVNode("option", { value: "tailles" }, "Vendu par taille", -1),
            _createElementVNode("option", { value: "melangees" }, "Couleur mélangée", -1)
          ]), 512), [
            [_vModelSelect, selectedVenduPar.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[12] || (_cache[12] = _createElementVNode("label", {
            for: "stockStatus",
            class: "block mb-2 font-medium"
          }, "Statut du stock", -1)),
          _withDirectives(_createElementVNode("select", {
            id: "stockStatus",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedStockStatus).value = $event)),
            class: "w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("option", { value: "" }, "Tous", -1),
            _createElementVNode("option", { value: "recorded" }, "Stock enregistré", -1),
            _createElementVNode("option", { value: "not_recorded" }, "Stock non enregistré", -1)
          ]), 512), [
            [_vModelSelect, selectedStockStatus.value]
          ])
        ]),
        _createElementVNode("div", { class: "flex items-end min-w-[120px]" }, [
          _createElementVNode("button", {
            onClick: clearAllFilters,
            class: "mt-6 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
          }, _cache[13] || (_cache[13] = [
            _createElementVNode("i", { class: "fas fa-times mr-1" }, null, -1),
            _createTextVNode(" Effacer les filtres ")
          ]))
        ])
      ]),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "flex items-center gap-2 mb-4 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg" }, [
        _createElementVNode("span", { class: "text-sm font-medium text-amber-700" }, "Stock"),
        _createElementVNode("span", { class: "inline-block w-6 text-center font-bold text-amber-600 border border-amber-300 rounded bg-amber-100" }, "-"),
        _createElementVNode("span", { class: "text-sm font-medium text-amber-700" }, "indique un produit dont le stock n'a pas encore été enregistré.")
      ], -1)),
      _createVNode(_unref(UnifiedPagination), {
        "total-items": totalProducts.value,
        "current-page": currentPage.value,
        "items-per-page": itemsPerPage.value,
        variant: "product",
        "item-label": "produits",
        "items-per-page-options": [10, 25, 50, 100],
        "show-first-last-buttons": true,
        "onUpdate:currentPage": handlePageChange,
        "onUpdate:itemsPerPage": handleItemsPerPageChange,
        onPageChange: handlePageChange,
        onItemsPerPageChange: handleItemsPerPageChange
      }, null, 8, ["total-items", "current-page", "items-per-page"]),
      _createElementVNode("div", _hoisted_7, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[14] || (_cache[14] = [
              _createElementVNode("span", { class: "inline-block w-5 h-5 border-2 border-gray-200 border-t-blue-500 rounded-full animate-spin mr-3" }, null, -1),
              _createElementVNode("span", { class: "text-gray-500" }, "Chargement...", -1)
            ])))
          : (filteredStocks.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[15] || (_cache[15] = [
                _createElementVNode("i", { class: "fas fa-box-open text-3xl mb-3" }, null, -1),
                _createElementVNode("p", null, "Aucun produit trouvé", -1)
              ])))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStocks.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.id
          }, [
            (!item.isChild)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
                'rounded-xl border transition-all duration-200 overflow-hidden',
                expandedReferenceId.value === item.id
                  ? item.venduPar === 'melangees'
                    ? 'border-purple-200 shadow-md ring-1 ring-purple-100'
                    : item.venduPar === 'tailles'
                    ? 'border-green-200 shadow-md ring-1 ring-green-100'
                    : 'border-blue-200 shadow-md ring-1 ring-blue-100'
                  : 'border-gray-200 hover:border-gray-300 hover:shadow-sm',
              ])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex items-center justify-between px-3 sm:px-5 py-1.5 sm:py-2 cursor-pointer select-none flex-wrap gap-2", [
                  expandedReferenceId.value === item.id
                    ? item.venduPar === 'melangees'
                      ? 'bg-purple-50/60'
                      : item.venduPar === 'tailles'
                      ? 'bg-green-50/60'
                      : 'bg-blue-50/60'
                    : 'bg-white hover:bg-gray-50/80',
                ]]),
                    onClick: ($event: any) => (toggleReferenceDropdown(item.id))
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: _withModifiers(($event: any) => (toggleReferenceDropdown(item.id)), ["stop"]),
                        class: _normalizeClass([
                      'w-7 h-7 flex items-center justify-center rounded-lg transition-all duration-200',
                      expandedReferenceId.value === item.id
                        ? item.venduPar === 'melangees'
                          ? 'bg-purple-500 text-white shadow-sm'
                          : item.venduPar === 'tailles'
                          ? 'bg-green-500 text-white shadow-sm'
                          : 'bg-blue-500 text-white shadow-sm'
                        : 'bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-gray-600',
                    ])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass([
                        'fas text-[10px] transition-transform duration-200',
                        expandedReferenceId.value === item.id
                          ? 'fa-chevron-down'
                          : 'fa-chevron-right',
                      ])
                        }, null, 2)
                      ], 10, _hoisted_12),
                      _createElementVNode("div", _hoisted_13, [
                        (item.image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.image,
                              alt: item.referenceBase || item.reference,
                              loading: "lazy",
                              class: "w-full h-full object-cover"
                            }, null, 8, _hoisted_14))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[16] || (_cache[16] = [
                              _createElementVNode("i", { class: "fas fa-tshirt text-gray-300 text-xs" }, null, -1)
                            ])))
                      ]),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(item.referenceBase || item.reference), 1),
                      (item.packQuantites && item.packQuantites.length > 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass([
                      'inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border',
                      item.isMelangee
                        ? 'bg-purple-50 text-purple-600 border-purple-200'
                        : 'bg-blue-50 text-blue-600 border-blue-200',
                    ])
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass([
                        'fas fa-box mr-1',
                        item.isMelangee ? 'text-purple-400' : 'text-blue-400',
                      ])
                            }, null, 2),
                            _createTextVNode(" Qté paquet : " + _toDisplayString(item.packQuantites.join("-")), 1)
                          ], 2))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold", getVenduParClass(item.venduPar)])
                      }, _toDisplayString(getVenduParLabel(item.venduPar)), 3),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(getColorCount(item)) + " couleur(s) ", 1)
                    ])
                  ], 10, _hoisted_10),
                  (expandedReferenceId.value === item.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (item.isMelangee)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-sm font-semibold text-purple-700" }, [
                                _createElementVNode("i", { class: "fas fa-cubes mr-1.5 text-purple-400" }),
                                _createTextVNode("Nombre de paquets ")
                              ], -1)),
                              _createElementVNode("div", _hoisted_21, [
                                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-xs text-gray-500" }, "Paquets en stock :", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((item.bundleCount) = $event),
                                  type: "number",
                                  min: "0",
                                  step: "1",
                                  class: "w-20 px-2 py-1.5 text-sm border border-purple-200 rounded-lg text-center bg-white focus:outline-none focus:ring-2 focus:ring-purple-300 focus:border-purple-400 transition-all",
                                  onInput: ($event: any) => (sanitizeNonNegativeInt(item, 'bundleCount')),
                                  onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                }, null, 40, _hoisted_22), [
                                  [
                                    _vModelText,
                                    item.bundleCount,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (saveBundleCount(item)),
                                  disabled: savingBundle.value === item.id,
                                  class: "px-4 py-1.5 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700 active:bg-purple-800 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm"
                                }, [
                                  (savingBundle.value === item.id)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _cache[17] || (_cache[17] = [
                                        _createElementVNode("span", { class: "w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin mr-1.5" }, null, -1),
                                        _createTextVNode(" Enregistrement... ")
                                      ])))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "Enregistrer paquets"))
                                ], 8, _hoisted_23)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getChildItems(item), (child, childIdx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: childIdx,
                              class: _normalizeClass([
                      'flex items-center gap-3 sm:gap-4 px-3 sm:px-5 py-2 sm:py-3 transition-colors duration-150 min-w-0 flex-wrap sm:flex-nowrap',
                      item.venduPar === 'melangees'
                        ? 'hover:bg-purple-50/30'
                        : item.venduPar === 'tailles'
                        ? 'hover:bg-green-50/30'
                        : 'hover:bg-blue-50/30',
                    ])
                            }, [
                              _createElementVNode("div", _hoisted_27, [
                                (child.image)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: child.image,
                                      alt: child.couleur || '',
                                      loading: "lazy",
                                      class: "w-full h-full object-cover"
                                    }, null, 8, _hoisted_28))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[20] || (_cache[20] = [
                                      _createElementVNode("i", { class: "fas fa-tshirt text-gray-300 text-xs" }, null, -1)
                                    ])))
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([
                          'text-sm font-semibold',
                          item.venduPar === 'melangees'
                            ? 'text-purple-700'
                            : item.venduPar === 'couleurs'
                            ? 'text-blue-700'
                            : 'text-green-700',
                        ])
                                }, _toDisplayString(child.couleur || "Sans couleur"), 3),
                                (child.size)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "(" + _toDisplayString(child.size) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                (
                          item.isMelangee &&
                          child.tailleStocks &&
                          child.tailleStocks.length > 0
                        )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-xs text-gray-400 mr-1" }, "Quantités par taille :", -1)),
                                      _createElementVNode("div", _hoisted_33, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.tailleStocks, (ts, tidx) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: tidx,
                                            class: "flex items-center gap-1 bg-purple-50/60 border border-purple-100 rounded-lg px-2 py-1"
                                          }, [
                                            _createElementVNode("span", _hoisted_34, _toDisplayString(ts.taille), 1),
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": ($event: any) => ((ts.quantity) = $event),
                                              type: "number",
                                              min: "0",
                                              step: "1",
                                              class: "w-11 px-1 py-0.5 text-xs border border-purple-200 rounded-md text-center bg-white focus:outline-none focus:ring-1 focus:ring-purple-300 transition-all",
                                              onInput: ($event: any) => (sanitizeNonNegativeInt(ts, 'quantity')),
                                              onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                            }, null, 40, _hoisted_35), [
                                              [
                                                _vModelText,
                                                ts.quantity,
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ], 64))
                                  : (
                          item.venduPar === 'tailles' &&
                          child.tailleStocks &&
                          child.tailleStocks.length > 0
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-xs text-gray-400 mr-1" }, "Stock par taille :", -1)),
                                        _createElementVNode("div", _hoisted_36, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.tailleStocks, (ts, tidx) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: tidx,
                                              class: "flex items-center gap-1 bg-green-50/60 border border-green-100 rounded-lg px-2 py-1"
                                            }, [
                                              _createElementVNode("span", _hoisted_37, _toDisplayString(ts.taille), 1),
                                              _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": ($event: any) => ((ts.quantity) = $event),
                                                type: "number",
                                                min: "0",
                                                step: "1",
                                                placeholder: ts.quantity === null ? '-' : '',
                                                class: "w-11 px-1 py-0.5 text-xs border border-green-200 rounded-md text-center bg-white focus:outline-none focus:ring-1 focus:ring-green-300 transition-all",
                                                onInput: ($event: any) => {
                                sanitizeNonNegativeInt(ts, 'quantity');
                                debouncedAutoSaveTailleStock(child, ts);
                              },
                                                onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                              }, null, 40, _hoisted_38), [
                                                [
                                                  _vModelText,
                                                  ts.quantity,
                                                  void 0,
                                                  { number: true }
                                                ]
                                              ]),
                                              (autoSaving.value[`${child.id}-${ts.taille}`])
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_39))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ], 64))
                                    : (
                          item.venduPar === 'couleurs' &&
                          child.tailleStocks &&
                          child.tailleStocks.length > 0
                        )
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-xs text-gray-400 mr-1" }, "Stock par taille :", -1)),
                                          _createElementVNode("div", _hoisted_40, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.tailleStocks, (ts, tidx) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: tidx,
                                                class: "flex items-center gap-1 bg-blue-50/60 border border-blue-100 rounded-lg px-2 py-1"
                                              }, [
                                                _createElementVNode("span", _hoisted_41, _toDisplayString(ts.taille), 1),
                                                _withDirectives(_createElementVNode("input", {
                                                  "onUpdate:modelValue": ($event: any) => ((ts.quantity) = $event),
                                                  type: "number",
                                                  min: "0",
                                                  step: "1",
                                                  placeholder: ts.quantity === null ? '-' : '',
                                                  class: "w-11 px-1 py-0.5 text-xs border border-blue-200 rounded-md text-center bg-white focus:outline-none focus:ring-1 focus:ring-blue-300 transition-all",
                                                  onInput: ($event: any) => {
                                sanitizeNonNegativeInt(ts, 'quantity');
                                debouncedAutoSaveTailleStock(child, ts);
                              },
                                                  onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                                }, null, 40, _hoisted_42), [
                                                  [
                                                    _vModelText,
                                                    ts.quantity,
                                                    void 0,
                                                    { number: true }
                                                  ]
                                                ]),
                                                (autoSaving.value[`${child.id}-${ts.taille}`])
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ])
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-xs text-gray-400 mr-1" }, "Stock :", -1)),
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": ($event: any) => ((child.stock) = $event),
                                            type: "number",
                                            min: "0",
                                            step: "1",
                                            placeholder: child.stock === null ? '-' : '',
                                            class: _normalizeClass([
                            'w-20 px-2 py-1.5 text-sm border rounded-lg text-center bg-white focus:outline-none focus:ring-1 transition-all',
                            item.venduPar === 'melangees'
                              ? 'border-purple-200 focus:ring-purple-300'
                              : item.venduPar === 'couleurs'
                              ? 'border-blue-200 focus:ring-blue-300'
                              : 'border-green-200 focus:ring-green-300',
                          ]),
                                            onChange: ($event: any) => (updateStock(child)),
                                            onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                          }, null, 42, _hoisted_44), [
                                            [
                                              _vModelText,
                                              child.stock,
                                              void 0,
                                              { number: true }
                                            ]
                                          ])
                                        ], 64))
                              ])
                            ], 2))
                          }), 128))
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass([
                    'flex justify-end px-3 sm:px-5 py-2 sm:py-3 border-t',
                    item.venduPar === 'melangees'
                      ? 'bg-purple-50/30 border-purple-100/60'
                      : item.venduPar === 'tailles'
                      ? 'bg-green-50/30 border-green-100/60'
                      : 'bg-blue-50/30 border-blue-100/60',
                  ])
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (saveAllChildren(item)),
                            disabled: saving.value === item.id,
                            class: _normalizeClass([
                      'px-6 py-2 text-sm font-semibold text-white rounded-lg shadow-sm whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 active:scale-[0.98]',
                      item.venduPar === 'melangees'
                        ? 'bg-purple-600 hover:bg-purple-700'
                        : item.venduPar === 'couleurs'
                        ? 'bg-blue-600 hover:bg-blue-700'
                        : 'bg-green-600 hover:bg-green-700',
                    ])
                          }, [
                            (saving.value === item.id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, _cache[25] || (_cache[25] = [
                                  _createElementVNode("span", { class: "w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin mr-1.5" }, null, -1),
                                  _createTextVNode(" Enregistrement... ")
                                ])))
                              : (_openBlock(), _createElementBlock("span", _hoisted_47, _cache[26] || (_cache[26] = [
                                  _createElementVNode("i", { class: "fas fa-save mr-1.5" }, null, -1),
                                  _createTextVNode("Enregistrer")
                                ])))
                          ], 10, _hoisted_45)
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ]))
}
}

})